import CustomBreadCrumbs from 'components/CustomBreadCrumbs';
import { useLoadingDocumentsPage } from 'hooks/useLoadingDocumentsPage';
import DocumentsTable from '../components/DocumentsTable';
import { useAppSelector } from 'utilities/hooks';
import { Empty, Flex, Spin } from 'antd';
import { useDocumentsNavigateTo } from '../../../hooks/useDocumentsNavigateTo';
import { useParamsSmx3Documents } from '../../../hooks/useParamsSmx3Documents';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { SmallStorageProgressBar } from '../../../components/StorageProgressBar/SmallStorageProgressBar';

const DefaultDocumentsPage = () => {
    const { navigateTo } = useDocumentsNavigateTo();
    const { breadcrumbs } = useAppSelector((state) => state.documents);
    const loading = useLoadingDocumentsPage();
    const smxId = useParamsSmx3Documents();

    if (smxId) {
        return (
            <Spin spinning={true} tip={'Loading...'}>
                <Empty description={'No data to display'} style={{ margin: '10% 0' }} />
            </Spin>
        );
    }

    return (
        <Flex vertical>
            <Flex justify={'space-between'}>
                <CustomBreadCrumbs
                    title="Documents"
                    loading={loading}
                    breadcrumbs={breadcrumbs}
                    onRootClick={() => {
                        navigateTo();
                    }}
                    onClick={(breadcrumb) => {
                        navigateTo(breadcrumb.id);
                    }}
                />
                <SmallStorageProgressBar />
            </Flex>
            <DndProvider backend={HTML5Backend}>
                <DocumentsTable hasFileTree={true} draggable={true} />
            </DndProvider>
        </Flex>
    );
};

export default DefaultDocumentsPage;
